const AUDIENCE = {
  LOGIN: 1046355,
  VISIT: 1046357,
  REG_FINISHED: 1046359
}

function firePixel(audienceId, remoteUid) {
  if (typeof window.rtp !== 'function') return
  window.rtp('mark', {
    audience_id: audienceId,
    remote_uid: remoteUid || '',
    cost: 0
  })
}

const BhaggoPixel = {
  install(Vue) {
    Vue.prototype.$bhaggoPixel = {
      fireVisit(remoteUid) {
        firePixel(AUDIENCE.VISIT, remoteUid)
      },
      fireLogin(remoteUid) {
        firePixel(AUDIENCE.LOGIN, remoteUid)
      },
      fireRegFinished(remoteUid) {
        firePixel(AUDIENCE.REG_FINISHED, remoteUid)
      }
    }
  }
}

export default BhaggoPixel
